import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Description, Information, Layout, MediaInfo, MetaSection, ShowName, Title } from './TeaserElement.styles';
import { useAnalyticsDispatch } from '../../analytics/AnalyticsContext';
import { useUdpSectionTracking } from '../../analytics/use-udp-section-tracking';
import { useHydrated } from '../../hooks/use-hydrated';
import { usePathByMediaType } from '../../hooks/use-path-by-media-type';
import { useMediaTeaserConfig } from '../../providers/UiConfigProvider/UiConfigContext';
import { dateOrWebFirstText } from '../../utils/media-helper';
import { createSeparatedList } from '../../utils/separated-list-helper';
import { SmartLink } from '../ClickableComponents/SmartLink';
import { DotSeparator } from '../DotSeparator/DotSeparator';
import { teaserElementImageWidth } from '../Image/image-width';
import { InfoLabel } from '../InfoLabel/InfoLabel';
import { getLabel, getLabelMap } from '../InfoLabel/label-helper';
import { useSectionMeta } from '../Section/SectionMetaProvider';
import { MediaTeaserWrapper } from '../Teaser/MediaTeaser/MediaTeaserWrapper';
import { useMediaInformation } from '../Teaser/MediaTeaser/use-media-information';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MediaElementContent = ({
  media,
  labelText,
  index
}) => {
  const {
    displayDate
  } = useMediaTeaserConfig();
  const [isHovering, setHover] = useState(false);
  const [isFocused, setFocus] = useState(false);
  const {
    t
  } = useTranslation();
  const analytics = useAnalyticsDispatch();
  const sectionMeta = useSectionMeta();
  const {
    sectionId,
    representationName,
    sectionTitle
  } = sectionMeta;
  const path = usePathByMediaType(media);
  const trackSection = useUdpSectionTracking();
  const {
    displayShowTitle
  } = useMediaTeaserConfig();
  const {
    title,
    description,
    season
  } = useMediaInformation(media);
  const isHydrated = useHydrated();
  const label = useMemo(() => getLabel(['live', 'default', 'expiringSoon'], getLabelMap(t, media, labelText)), [labelText, media, t]);
  const list = [displayShowTitle && media?.show?.title && /*#__PURE__*/_jsx(ShowName, {
    children: media.show.title
  }), season ? /*#__PURE__*/_jsx("span", {
    children: season
  }) : !label && displayDate && isHydrated && media && /*#__PURE__*/_jsx("span", {
    children: dateOrWebFirstText(media.date, t, 0)
  })];
  const dotSeparatedList = createSeparatedList(list, /*#__PURE__*/_jsx(DotSeparator, {}));
  return /*#__PURE__*/_jsxs(Layout, {
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false),
    onFocus: () => setFocus(true),
    onBlur: () => setFocus(false),
    children: [/*#__PURE__*/_jsx(MediaTeaserWrapper, {
      media: media,
      index: index,
      hasBorderRadius: false,
      isHoveringParent: isHovering,
      isFocusedParent: isFocused,
      imageWidth: teaserElementImageWidth
    }), /*#__PURE__*/_jsx(SmartLink, {
      to: path,
      state: {
        media
      },
      isInternal: true,
      onClick: () => {
        if (sectionId || representationName) {
          analytics({
            type: 'click-event',
            name: 'MediaElementInformationClick',
            value1: media.urn,
            value2: sectionId,
            value3: sectionTitle,
            value4: representationName
          });
          trackSection({
            sectionMeta,
            item: {
              ...media,
              index
            }
          });
        }
      },
      children: /*#__PURE__*/_jsxs(Information, {
        children: [/*#__PURE__*/_jsxs(MetaSection, {
          children: [label && /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(InfoLabel, {
              type: label?.type,
              text: label?.text
            })
          }), dotSeparatedList.length > 0 && /*#__PURE__*/_jsx(MediaInfo, {
            children: dotSeparatedList
          })]
        }), /*#__PURE__*/_jsx(Title, {
          children: title
        }), description && /*#__PURE__*/_jsx(Description, {
          children: description
        })]
      })
    })]
  });
};